import { useState, useContext } from "react";
import { Box } from "@mui/material";
import { BrandContext } from "../../App";
import landingbg from "../../assets/GNBackground.png";

import { TopNav } from "./TopNav";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import SideMenu from "./SideMenu";

import BreadCrumbs from "../Breadcrumbs/Breadcrumbs";

import { useUI } from "../../contexts/UIContext";

export function LandingLayout(props) {
  const { sideMenuOpen, setSideMenuOpen, isMobile, theme } = useUI();
  const [mobileDrawOpen, setMobileDrawOpen] = useState(false);

  const toggleDrawer = () => {
    setSideMenuOpen((prev) => !prev);
  };

  return (
    <div className="app-container">
      {/* Mobile header here */}
      <header></header>
      <Box
        sx={{
          display: "flex",
          width: 1,
          minHeight: "100vh",
          backgroundColor: theme.palette.background.primary,
        }}
      >
        {/* Needs reworking slightly to show/hide on mobile and then slide from the burger menu that
         will be on the right hand side of the mobile menu */}
        <SideMenu
          open={sideMenuOpen}
          toggleDrawer={toggleDrawer}
          permanent={!isMobile}
          toggleMobileDrawer={() => setMobileDrawOpen(!mobileDrawOpen)}
        />

        <Box sx={{ display: "flex", flexDirection: "column", flexGrow: 1 }}>
          <BreadCrumbs />
          <TopNav minimal={props.topnavminimal} />

          <Box sx={{ flexGrow: 1, overflow: "auto" }}>{props.children}</Box>
        </Box>
      </Box>
    </div>
  );
}
